import React, { Fragment, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Turnstile, { useTurnstile } from 'react-turnstile';

export default function UploadCaptcha({ isOpen, setIsOpen, cb }) {
  const turnstile = useTurnstile();

  useEffect(() => {
    try {
      if (turnstile) turnstile.reset();
    } catch (error) {

    }
  }, [isOpen])

  function onVerify(token) {
    setIsOpen(false)
    turnstile.reset();
    cb(token);
  }

  return (
    <>
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel 
                className={`w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
              >
                <Dialog.Title
                  as="h3"
                  className="text-2xl mb-4 font-semibold leading-6 text-gray-900"
                >
                  <span>Captcha</span>
                </Dialog.Title>
                <Turnstile sitekey='0x4AAAAAAAkbPwItxVr1XPuz' onVerify={token => onVerify(token)} theme="light" className='flex justify-center' />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  </>
  )
}
